import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import SEOHead from '../../components/base/SEOHead';

export default function PrivacyPage() {
  const { i18n, t } = useTranslation();
  const isEnglish = i18n.language === 'en';
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEOHead
        title={t('seo.privacy.title')}
        description={t('seo.privacy.description')}
        keywords="zpracování osobních údajů, GDPR, ochrana dat, osobní údaje žehlení, práva subjektu údajů"
      />
      
      <div className="min-h-screen bg-gradient-to-br from-teal-50 via-white to-teal-50">
        <Navbar />
        
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
          {/* Hlavička */}
          <div className="text-center mb-16">
            <h1 className="text-5xl font-bold text-gray-900 mb-4">
              Zpracování osobních údajů
            </h1>
            <p className="text-xl text-gray-600">
              Ochrana vašich osobních údajů je naší prioritou
            </p>
            <p className="text-sm text-gray-500 mt-4">
              Platné od: 1. ledna 2025 | V souladu s GDPR (EU) 2016/679
            </p>
          </div>

          {/* Obsah */}
          <div className="bg-white rounded-2xl shadow-lg p-8 lg:p-12 space-y-8">
            
            {/* Úvod */}
            <section>
              <div className="bg-gradient-to-br from-indigo-50 to-purple-50 border-2 border-indigo-200 rounded-xl p-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-shield-check-line text-2xl text-indigo-600"></i>
                  </div>
                  <div>
                    <h2 className="text-xl font-bold text-gray-900 mb-2">
                      Ochrana vašich údajů
                    </h2>
                    <p className="text-gray-700 leading-relaxed">
                      Tento dokument vás informuje o tom, jak zpracováváme vaše osobní údaje v souladu s nařízením Evropského parlamentu a Rady (EU) 2016/679 o ochraně fyzických osob v souvislosti se zpracováním osobních údajů (GDPR).
                    </p>
                  </div>
                </div>
              </div>
            </section>

            {/* Správce */}
            <section className="border-t-2 border-gray-100 pt-8">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-building-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-3">
                    1. Správce osobních údajů
                  </h2>
                  <div className="bg-teal-50 border-2 border-teal-200 rounded-lg p-4">
                    <p className="font-bold text-gray-900 mb-2">VYŽEHLENÉ</p>
                    <div className="space-y-1 text-sm text-gray-700">
                      <p className="flex items-center gap-2">
                        <i className="ri-phone-line text-teal-600"></i>
                        Praha: +420 776 166 733
                      </p>
                      <p className="flex items-center gap-2">
                        <i className="ri-phone-line text-teal-600"></i>
                        Stará Boleslav: +420 603 290 573
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* ... (the rest of the page remains unchanged) ... */}
          </div>

          {/* Zpět na hlavní stránku */}
          <div className="text-center mt-12">
            <button
              onClick={() => window.REACT_APP_NAVIGATE('/')}
              className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-pink-600 to-pink-500 text-white rounded-lg font-semibold hover:from-pink-700 hover:to-pink-600 transition-all shadow-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-arrow-left-line text-xl"></i>
              Zpět na hlavní stránku
            </button>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}